var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 15H3.34004C2.05216 15 1 13.9478 1 12.66V3.34004C1 2.05216 2.05216 1 3.34004 1H12.66C13.9478 1 15 2.05216 15 3.34004V12.66C15 13.9536 13.9536 15 12.66 15Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46231 10.5449C6.14075 11.2233 7.04342 11.597 8.00358 11.597C8.96375 11.597 9.86067 11.2233 10.5449 10.5449C11.2233 9.86642 11.597 8.96375 11.597 8.00359C11.597 7.04342 11.2233 6.14075 10.5449 5.46231C9.86642 4.78387 8.96375 4.41016 8.00358 4.41016C7.04342 4.41016 6.14075 4.78387 5.46231 5.46231C4.78387 6.14075 4.41016 7.04342 4.41016 8.00359C4.41016 8.96375 4.78387 9.86642 5.46231 10.5449Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2954 4.29202C12.6765 4.29202 12.9854 3.98312 12.9854 3.60207C12.9854 3.22101 12.6765 2.91211 12.2954 2.91211C11.9144 2.91211 11.6055 3.22101 11.6055 3.60207C11.6055 3.98312 11.9144 4.29202 12.2954 4.29202Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.51cf58695257a9bdbab272541d905bdb.svg";
export { ForwardRef as ReactComponent };